import {
  setLoadingConfigObject,
  shimmerPlaceholderConfig,
} from '@vfgroup-oneplatform/foundation/Components/Shimmer/Shimmer.utils';

import styles from './AddOnsLoading.Config.styles';

const loadingConfig = theme => [
  {
    main: setLoadingConfigObject('square', 1, null, styles.buyButton),
  },
  {
    right: setLoadingConfigObject('line', 1, 165, styles.addonsViewType),
  },
];

export { loadingConfig, shimmerPlaceholderConfig };
